<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showMerchantCompanyConfirmSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
        <div style="margin: 20px 0px 0px 5px;">
            <div class="header-title">About your company</div>
        </div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading">
        <div class="promo-detail-body">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(80vh)'}"
                           [styleClass]="'app-scrollpanel'">
                <div class="merchant-form">
                    <div class="merchant-label">Registered company name (same as SEC document) *</div>
                    <input type="text" [(ngModel)]="merchantCompany.BusinessName" placeholder="Type here…" pInputText />
                </div>

                <div class="merchant-form">
                    <div class="merchant-label">Registered company address (same as SEC document) *</div>
                    <input type="text" [(ngModel)]="merchantCompany.BusinessAddress" placeholder="Address…" pInputText />
                </div>

                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label"></div>
                            <input type="text" [(ngModel)]="merchantCompany.BusinessCity" placeholder="City" pInputText />
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label"></div>
                            <input type="text" [(ngModel)]="merchantCompany.BusinessPostalCode" placeholder="Postal code" pInputText />
                        </div>
                    </div>
                </div>

                <div class="merchant-form">
                    <div class="merchant-label">Trading name (what will be published in app) *</div>
                    <input type="text" [(ngModel)]="merchantCompany.TradingName" placeholder="Type here…" pInputText />
                </div>

                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Company Phone</div>
                            <input type="text" [(ngModel)]="merchantCompany.BusinessPhone" placeholder="+63" pInputText />
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Company Email</div>
                            <input type="text" [(ngModel)]="merchantCompany.BusinessEmail" placeholder="Email" pInputText />
                        </div>
                    </div>
                </div>
            </p-scrollPanel>
            <hr class="hr-filter" />
            <div class="flex justify-content-end mrg-10-0px">
                <button class="bluedark-btn" pButton label="Confirm" (click)="confirm()"></button>
            </div>
        </div>

    </div>

</p-sidebar>